module.exports = __webpack_public_path__ + "img/cj_2.3e8b352c.png";